import React, { useState } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";

export default function MultiplesDates() {
  const [startDate, setStartDate] = useState<DateObject[]>([]);
  const handleChange = (dates: DateObject[]) => setStartDate(dates);

  return <DatePicker inputClass="form-control" multiple value={startDate} onChange={handleChange} />;
}
